import script from "./MoleculeTransferLicenseModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTransferLicenseModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTransferLicenseModal.vue?vue&type=style&index=0&id=13567b28&lang=css"

const __exports__ = script;

export default __exports__